/**
 * @module Split Section - Image + Content
 * @description Split Section 50/50
 */
import DynamicButton from "@/blocks/Buttons/DynamicButton";
import PropTypes from "prop-types";
import Image from "next/legacy/image";
import { fastly, fastlyBlur } from "@/js/utils/helpers";
import styles from "./index.module.css";

const defaultImage = {
  url: "/pages/home/split-section-720x514.jpg",
  blurUrl: "/pages/home/split-section-720x514.jpg",
  alt: "Woman wearing VR - 2G text",
};

const position = "SPLIT SECTION COPY";

/**
 * @function Component
 * @description
 */
const Component = ({ ...props }) => {
  const {
    title = (
      <>
        Introducing Fiber 2 Gig{" "}
        <span key="span-1">- our most advanced Wi-Fi ever.</span>
      </>
    ),
    subtitle = "Subtitle",
    content,
    theme = null,
    reverseLayout = false,
    objectFit = "cover",
    objectPosition = "center",
  } = props;
  let { image = defaultImage } = props;
  image = { ...image, defaultImage };

  return (
    <>
      <section
        className={`component ${styles.component} ${theme && `u-theme-${theme}`}`}
      >
        <div
          className={`${styles.component__backgroundWrap} ${styles.component__backgroundWrapMobile}`}
        >
          <div
            className={`${styles.component__background} ${styles.component__backgroundMobile}`}
          >
            <Image
              alt={image.alt}
              src={image.url}
              loader={fastly}
              placeholder="blur"
              loading="lazy"
              blurDataURL={fastlyBlur(image.blurUrl)}
              layout="fill"
              objectFit={objectFit}
              objectPosition={objectPosition}
            />
          </div>
          {/* <!-- .component__background --> */}
        </div>

        <div className="l-container">
          <div
            className={`g-row g-row--match-height ${!reverseLayout && "g-row--reorder-2-col"}`}
          >
            <div className="g-col g-col--one-half">
              <div
                className={`${styles.component__content} ${reverseLayout && styles.component__contentReverse}`}
              >
                <h2 className={`${styles.component__title}`}>{title}</h2>
                {subtitle && (
                  <p className={`h6 ${styles.component__subtitle}`}>
                    {subtitle}
                  </p>
                )}

                {content.map((item, index) => (
                  <div
                    key={index}
                    className={item.icon && styles.component__copyContainer}
                  >
                    {item.headline && (
                      <h3
                        className={`h5 component__itemHeading ${styles.component__itemHeading}`}
                      >
                        {item.headline}
                      </h3>
                    )}
                    {item.icon && (
                      <span
                        className={`icon icon-checkmark1 ${styles.component__icon} ${theme && styles[`component__icon__${theme}`]} `}
                      />
                    )}
                    <p className={item.icon && styles.component__copy}>
                      {item.copy}
                    </p>
                  </div>
                ))}

                <DynamicButton type="cart" position={position} />
              </div>
              {/* <!-- .component__content --> */}
            </div>
            {/* <!-- .g-col --> */}

            <div className="g-col g-col--one-half">
              <div
                className={`${styles.component__backgroundWrap} ${reverseLayout && styles.component__backgroundWrapReverse}`}
              >
                <div className={styles.component__background}>
                  <Image
                    alt={image.alt}
                    src={image.url}
                    loader={fastly}
                    placeholder="blur"
                    blurDataURL={fastlyBlur(image.blurUrl)}
                    layout="fill"
                    loading="lazy"
                    objectFit={objectFit}
                    objectPosition={objectPosition}
                  />
                </div>
              </div>
              {/* <!-- .component__backgroundWrap --> */}
            </div>
            {/* <!-- .g-col --> */}
          </div>
          {/* <!-- .g-row --> */}
        </div>
      </section>
      {/* <!-- .component --> */}
    </>
  );
};

Component.propTypes = {
  title: PropTypes.node,
  subtitle: PropTypes.node,
  image: PropTypes.shape({
    url: PropTypes.string,
    blurUrl: PropTypes.string,
    alt: PropTypes.string,
  }),
  content: PropTypes.arrayOf(
    PropTypes.shape({
      headline: PropTypes.node,
      copy: PropTypes.node,
    }),
  ),
  theme: PropTypes.string,
  reverseLayout: PropTypes.bool,
};

export default Component;
